import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateSortingSelectComponent } from './date-sorting-select.component';
import { SelectModule } from "@airnauts/ng-components/select";
import { ReactiveFormsModule } from "@angular/forms";


@NgModule({
  declarations: [
    DateSortingSelectComponent,
  ],
  imports: [
    CommonModule,
    SelectModule,
    ReactiveFormsModule,
  ],
  exports: [DateSortingSelectComponent],
})
export class DateSortingSelectModule { }
